import React, { Component } from 'react';
import { connect } from 'dva';
import './menuContainer.less';
import MeunPanel from './menuPanel';
import { MenuCardColors } from '../utils';

export interface IABSMenuContainerProps {
  menu: any;
  dispatch: any;
  homePageDetail: any;
  login: boolean;
}

class MenuContainer extends Component<IABSMenuContainerProps> {
  componentDidMount() {
    this.props.dispatch({
      type: 'home/getHomePageDetail',
    });
  }

  render() {
    const { menu, homePageDetail, login } = this.props;
    const { functions : hotMenu } = homePageDetail;
    const { siteMenus } = menu;
    if (siteMenus && Array.isArray(siteMenus)) {
      let totolLength = 0;
      return siteMenus.map((item, key) => {
        if (item && item.children && item.children.length > 0) {
          return <MeunPanel login={login} menuItem={item} menuColor={MenuCardColors[(totolLength++) % 5]} hotMenu={hotMenu} menuColorIndex={((totolLength - 1) % 5) + 1}/>;
        }
        return null;
      });
    } else {
      return null;
    }
  }
}

function mapStateToProps({ home, global }: any) {
  const { homePageDetail } = home;
  return { homePageDetail, menu: global.menu };
}

export default connect(mapStateToProps)(MenuContainer); 



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/left/components/menuContainer.tsx